import React from 'react';

import { useRestrictedActionShowState, useRestrictedActionShowActions } from './RestrictedActionShowContext';
import Form from '../../Shared/UI/Form/components/Form';
import Field from '../../Shared/UI/Field/components/Field';
import Input from '../../Shared/UI/Input/components/Input';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';

import { addRoleToRestrictedAction } from './restApi';

const AddRoleForm = ({ restrictedAction }) => {
  const state = useRestrictedActionShowState();
  const { onResponse, onError, updateNewRoleId, closeAddRoleModal } = useRestrictedActionShowActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const handleSubmit = () => {
    addRoleToRestrictedAction({
      restrictedAction,
      onResponse,
      onError,
      body: {
        newRole: state?.newRole,
        authenticity_token: authenticityToken,
      },
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Field label="Role ID" id="roleId">
        <Input
          type="text"
          value={state?.newRole?.id || ''}
          onChange={(e) => {
            updateNewRoleId(e.target.value);
          }}
        />
      </Field>

      <ResponsiveContainer name="form-actions">
        <FormActions>
          <Button
            variant="secondary"
            onClick={() => {
              closeAddRoleModal();
            }}
          >
            Cancel
          </Button>
          <Button type="submit">
            Add Role
          </Button>
        </FormActions>
      </ResponsiveContainer>
    </Form>
  );
};

export default AddRoleForm;
